function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../../../_snowpack/pkg/react.js';
import { colors } from '../../../css/index.js';

function EmptyCalendar({
  size = 20,
  color = colors.green,
  strokeColor = colors.label,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M4.63105 4H14H15L15.5 5.5L16 9L4.5 8L4 5L4.63105 4Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8H11H15.5L16 10L15.5 15L15 16H8.5H5H4.5L4 15L4.5 13V10V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18038 3.6001H14.1528C14.8372 3.6001 15.4212 4.09488 15.5337 4.76994L15.6547 5.49557C16.1518 8.47802 16.1518 11.5222 15.6547 14.5046L15.5337 15.2303C15.4212 15.9053 14.8372 16.4001 14.1528 16.4001H5.18038C4.31526 16.4001 3.6572 15.6233 3.79942 14.7699L3.86556 14.3731C4.34812 11.4777 4.34812 8.52246 3.86556 5.62708L3.79942 5.23026C3.6572 4.37691 4.31526 3.6001 5.18038 3.6001ZM5.18038 4.0001C4.56244 4.0001 4.09239 4.55496 4.19398 5.1645L4.26012 5.56133C4.74994 8.50024 4.74994 11.5 4.26012 14.4389L4.19398 14.8357C4.09239 15.4452 4.56244 16.0001 5.18038 16.0001H14.1528C14.6416 16.0001 15.0588 15.6467 15.1392 15.1645L15.2601 14.4389C15.7499 11.5 15.7499 8.50024 15.2601 5.56133L15.1392 4.8357C15.0588 4.35351 14.6416 4.0001 14.1528 4.0001H5.18038Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7211 8.20029L4.44434 8.20029L4.44434 7.80029L15.7211 7.80029L15.7211 8.20029Z",
    fill: strokeColor
  }));
}

export default /*#__PURE__*/forwardRef(EmptyCalendar);